export default __webpack_public_path__ + "static/media/icon-share-twitter.ee69d1c9.svg";